<div class="flex flex-col justify-stretch gap-3 px-4 mt-4">
	@if (monthlyEntries$.value$ | async; as values) {
	<mat-card class="data-table-card pb-4">
		<mat-card-header class="data-table-card-header !h-14 items-end">
			<div class="scroll-x -ml-8 text-nowrap w-full">
				<div
					(matSortChange)="changeDataSort($event)"
					[matSortActive]="activeSort?.active"
					[matSortDirection]="activeSort?.direction"
					[matSortDisabled]="viewOnlyOwnContingent | async"
					class="
					grid
					grid-cols-[minmax(250px,1fr)_120px_140px_1fr]
					lg:grid-cols-[minmax(310px,400px)_minmax(120px,1fr)_minmax(120px,1fr)_minmax(120px,1fr)_0px_220px_minmax(40px,1fr)]
					xl:grid-cols-[minmax(310px,400px)_minmax(120px,1fr)_minmax(120px,1fr)_minmax(120px,1fr)_minmax(100px,200px)_220px_minmax(40px,1fr)]
					gap-4
					items-center
					px-6
					[&>div]:rounded-t"
					matSort
				>
					<div
						class="cursor-pointer "
						mat-sort-header="name"
						matRipple
					>
						<span translate>utils.name</span>
					</div>
					<div class="hidden xl:block"></div>
					<div class="hidden xl:block"></div>
					<div
						class="cursor-pointer flex justify-center"
						mat-sort-header="contingent"
						matRipple
					>
						<div class="flex gap-1">
							<span class="ml-4">{{ 'workspace.timecontingent.account' | translate }}</span>
						</div>
					</div>
					<div class="hidden xl:block lg:block"></div>
					<div class="tr-group flex flex-row items-center justify-center rounded-full py-1">
						<!-- <button
							mat-button
							class="tr-mid-btn mr-3"
							(click)="openCalPicker()"
							[matTooltip]=" 'workspace.timecontingent.showUntil' | translate">
							<mat-icon> calendar_month</mat-icon>
							{{ this.untilDate.value | formatDate: 'PP' }}
						</button> -->
						@if(range$ | async; as vd) {
						<button
							(click)="dayPickerPopover.toggle()"
							[disabled]="this.isLoading$ | async"
							[matTooltip]="'utils.pickTimeRange' | translate"
							[satPopoverAnchor]="dayPickerPopover"
							class="mt-1 h-10 flex items-center justify-start gap-1"
							mat-button
						>
							<ng-container>
								<mat-icon> calendar_month</mat-icon>
								<span>{{ vd.start | formatDate: 'PP' }}</span>
							</ng-container>
						</button>
						}
					</div>
					<div></div>
				</div>
			</div>
		</mat-card-header>
		<mat-card-content class="pb-4 rounded-b-lg">
			<div class="flex flex-col w-full">
				@if (loading.value$ | async) {
				<div
					*ngFor="let i of [0, 0, 0, 0, 0]"
					class="
						grid
						grid-cols-[minmax(250px,1fr)_120px_140px_1fr]
						lg:grid-cols-[minmax(310px,400px)_minmax(120px,1fr)_minmax(120px,1fr)_minmax(120px,1fr)_0px_220px_minmax(40px,1fr)]
						xl:grid-cols-[minmax(310px,400px)_minmax(120px,1fr)_minmax(120px,1fr)_minmax(120px,1fr)__minmax(100px,200px)_220px_minmax(40px,1fr)]
						grid-rows-[28px]
						content-center
						gap-4
						h-[58px]
						px-4"
				>
					<div class="mat-skeleton hidden xl:block "></div>
					<div class="mat-skeleton hidden xl:block "></div>
					<div class="mat-skeleton hidden xl:block lg:block"></div>
					<div class="mat-skeleton"></div>
					<div class="mat-skeleton"></div>
					<div class="mat-skeleton"></div>
					<div class="mat-skeleton"></div>
				</div>
				} @else {
				<mat-accordion
					[displayMode]="'flat'"
					[multi]="true"
					class="mat-accordion-cards mat-elevation-z0 rounded-0"
				>
					@for (tc of values; track tc.id; let last = $last) {
					<mat-expansion-panel
						[class.brd-b]="!last"
						[disabled]="!tc.monthOverview?.length"
						[expanded]="this.openUser == tc.id"
						[hideToggle]="true"
						[ngClass]="{
							'cursor-default!': !tc.monthOverview?.length,
						 }"
						#panel
						class="mat-elevation-z0 mat-expansion-card mat-expansion-card-flat"
						togglePosition="before"
						togglePosition="end"
					>
						<mat-expansion-panel-header
							[ngClass]="{ '!pr-4': !tc.enabled || tc.future,
								'bg-primary/5': tc.id == currentUser && values.length > 1,
							   }"
							class="group"
							collapsedHeight="58px"
							expandedHeight="58px"
						>
							<div
								class="
									grid
									grid-cols-[minmax(250px,1fr)_120px_140px_1fr]
									lg:grid-cols-[minmax(310px,400px)_minmax(120px,1fr)_minmax(120px,1fr)_minmax(120px,1fr)_0px_220px_minmax(40px,1fr)]
									xl:grid-cols-[minmax(310px,400px)_minmax(120px,1fr)_minmax(120px,1fr)_minmax(120px,1fr)_minmax(100px,200px)_220px_minmax(40px,1fr)]
									gap-4
									w-full
									items-center
								"
							>
								<div class="flex items-center w-full">
									<div class="h-10 w-10 flex-shrink-0">
										<app-user-avatar
											[userId]="tc.id"
											class="rounded-full"
											size="100%"
										> </app-user-avatar>
									</div>

									<span class="pl-4 leading-[1.185] text-secondary">
										{{ tc.user.name | parseName }}
									</span>
								</div>
								@if (tc.enabled) {
								<div class="hidden xl:block">
									<!-- @if (panel.expanded){
									<span class="flex justify-center"
									[ngClass]="tc.workinghours < 0.0 ? 'text-warn' : tc.workinghours > 0.0 ? 'text-success' : 'text-secondary'">
									{{ tc.workinghours > 0.0 ? '+' : '&#8199;' }}
									{{ tc.workinghours | parseMsAsDuration: false : true }}
									</span>
									} -->
								</div>
								<div class="hidden xl:block">
									<!-- @if (panel.expanded){
									<span class="flex justify-center"
									[ngClass]="tc.credit < 0.0 ? 'text-warn' : tc.credit > 0.0 ? 'text-success' : 'text-secondary'">
									{{ tc.credit > 0.0 ? '+' : '&#8199;' }}
									{{ tc.credit | parseMsAsDuration: false : true }}
									</span>
									} -->
								</div>
								<div
									[matTooltip]=" tc.credit != 0 ? ('workspace.timecontingent.plusAdjustments' | translate : { sufix : tc.credit > 0 ? '+' : '' , credits: tc.credit | parseMsAsDuration: false : true } ): null "
									class="whitespace-nowrap flex justify-center"
								>
									<span
										[ngClass]="tc.contingent < 0.0 ? 'text-warn' : tc.contingent > 0.0 ? 'text-success' : 'text-secondary'"
										class="font-semibold flex justify-center"
									>
										{{ tc.contingent > 0.0 ? '+' : '&#8199;' }}
										{{ tc.contingent | parseMsAsDuration: false : true }}
									</span>
								</div>
								<div class="flex items-center justify-center hidden xl:block lg:block">
									@if (panel.expanded && tc.supervisors; as supervisors) {
									<ng-container
										*ngTemplateOutlet="userListView; context: { $implicit: supervisors }"
									> </ng-container>
									}
								</div>
								} @else if (tc.future) {
								<div class="col-span-4 flex items-center">
									<span class="font-semibold text-sm text-muted">
										{{ 'workspace.timecontingent.employmentDateInFuture' | translate }}
									</span>
								</div>
								} @else if (!tc.enabled && viewOnlyOwnContingent | async ) {
								<div class="col-span-4 flex items-center whitespace-pre-line">
									<span class="font-semibold text-sm text-muted">
										{{ 'workspace.timecontingent.noEmploymentDateNonAdmin' | translate }}
									</span>
								</div>
								} @else if (!tc.enabled) {
								<div class="col-span-4 flex items-center">
									<span class="font-semibold text-sm text-muted">
										{{ 'workspace.timecontingent.employmentDateRequirement' | translate }}
									</span>
								</div>
								}
								<div
									[matTooltip]=" 'workspace.timecontingent.lastCalculated' | translate "
									class="whitespace-nowrap flex items-center justify-center"
								>
									@if ( !panel.expanded && tc.enabled && tc.lastModified > 0 &&
									(isOnMaxLastModifiedDate$ | async) ) {
									<span class="text-mute flex flex-col items-center text-center">
										<span>{{ tc.lastModified | formatDate: 'time' }}</span>
										@if (!isToday(tc.lastModified)) {
										<span class="text-xs">{{ tc.lastModified | formatDate: 'date' }}</span>
										}
									</span>
									}
								</div>
								<div class="flex items-center gap-4 justify-end">
									@if(isAdmin$.value) {
									<button
										(click)="this.editUser(tc.id); $event.stopPropagation();"
										class="opacity-0 group-hover:opacity-100"
										mat-icon-button
										translate
									>
										<mat-icon>edit</mat-icon>
									</button>
									}
								</div>
							</div>
						</mat-expansion-panel-header>
						<ng-template matExpansionPanelContent>
							<div class="flex flex-col">
								<div
									class="
									grid
									grid-cols-[minmax(250px,1fr)_120px_140px_1fr]
									lg:grid-cols-[minmax(310px,400px)_minmax(120px,1fr)_minmax(120px,1fr)_minmax(120px,1fr)_0px_220px_minmax(40px,1fr)]
									xl:grid-cols-[minmax(310px,400px)_minmax(120px,1fr)_minmax(120px,1fr)_minmax(120px,1fr)_minmax(100px,200px)_220px_minmax(40px,1fr)]
									gap-4
									items-center
									px-4
									h-10
									border-b
									border-muted
									text-muted-foreground"
								>
									<div class="ml-[64px]">{{ "utils.months" | translate }}</div>
									<div class="text-center hidden xl:block">
										{{ "workspace.timecontingent.workinghours" | translate }}
									</div>
									<div class="text-center hidden xl:block">
										{{ "workspace.timecontingent.creditdeduct" | translate }}
									</div>
									<div class="text-center">{{ "workspace.timecontingent.account" | translate }}</div>
									<div class="hidden xl:block lg:block"></div>
									<div class="hidden xl:block "></div>
									<div></div>
								</div>
								@for (month of tc.monthOverview; track month.date) {
								<div
									class="
									grid
									grid-cols-[minmax(250px,1fr)_120px_140px_1fr]
									lg:grid-cols-[minmax(310px,400px)_minmax(120px,1fr)_minmax(120px,1fr)_minmax(120px,1fr)_0px_220px_minmax(40px,1fr)]
									xl:grid-cols-[minmax(310px,400px)_minmax(120px,1fr)_minmax(120px,1fr)_minmax(120px,1fr)_minmax(100px,200px)_220px_minmax(40px,1fr)]
									gap-4
									items-center
									px-4
									h-11
									border-b
									border-muted/50
									hover:bg-muted/40
									transition-colors"
								>
									<div class="ml-[64px]">{{ month.date | date:'MMMM yyyy' }}</div>
									<ng-container
										*ngTemplateOutlet="monthContingentColumn;context:{ date: month.date, summed: month.totalBalanceSummed, change:month.totalBalance, hidden :true}"
										class="text-center"
									></ng-container>
									@if(month.creditSummed != 0 ) {
									<ng-container
										*ngTemplateOutlet="monthContingentColumn;context:{ date: month.date, summed: month.creditSummed, change:month.credit, hidden :true }"
										class="text-center"
									></ng-container>
									} @else {
									<div class="justify-center hidden xl:flex">
										<span class="flex justify-center text-center font-semibold"> – </span>
									</div>
									}
									<ng-container
										*ngTemplateOutlet="monthContingentColumn;context:{ date: month.date, summed: month.contingentSummed, change:month.gains }"
										class="text-center"
									></ng-container>
									<div class="hidden xl:block lg:block"></div>
									<div class="flex justify-center">
										@if(canViewDashboard$.value.workingHoursPermission) {
										<button
											(click)="openUsersMonthInDashboard(tc.id, month.date)"
											[matTooltip]="'dashboard.openMonth' | translate"
											class="mat-stroked-button"
											translate
										>
											workspace.timecontingent.monthlyDetails
										</button>
										}
									</div>
									<div class="hidden xl:block"></div>
								</div>
								}
							</div>
						</ng-template>
					</mat-expansion-panel>
					}
				</mat-accordion>
				}
			</div>
		</mat-card-content>
	</mat-card>
	}
</div>

<ng-template
	#userListView
	let-users
>
	<div class="flex items-center -space-x-3">
		<div
			[matTooltipTemplate]="userListViewTooltip"
			[matTooltipTemplateContext]="{ user: user }"
			*ngFor="let user of users | slice: 0 : 2; trackProp: 'id'"
			class="border-card relative size-9 overflow-hidden rounded-full"
			matTooltip
		>
			<app-user-avatar
				[userId]="user.id"
				size="100%"
			></app-user-avatar>
		</div>
		<div
			[matTooltipTemplate]="supervisorListView"
			[matTooltipTemplateContext]="{ users: users }"
			*ngIf="users.length > 2"
			class="border-card mat-bg-card flex size-9 items-center justify-center rounded-full font-bold"
			matTooltip
		>
			...
		</div>
	</div>
</ng-template>
<ng-template
	#userListViewTooltip
	let-user="user"
>
	<div class="flex flex-col">
		<div class="text-sm text-muted">
			{{ 'workspace.supervisors.name' | translate | replaceString: '\\(s\\)$' : '' : true : 'g' }}
		</div>
		<div>{{ user.name }}</div>
	</div>
</ng-template>
<ng-template
	#supervisorListView
	let-users="users"
>
	<div class="flex  flex-row items-center -space-x-3">
		<div
			*ngFor="let user of users; trackProp: 'id'"
			class="border-card relative size-9 overflow-hidden rounded-full"
		>
			<app-user-avatar
				[userId]="user.id"
				size="100%"
			></app-user-avatar>
		</div>
	</div>
</ng-template>

<ng-template
	#monthContingentColumn
	let-change="change"
	let-date="date"
	let-hidden="hidden"
	let-summed="summed"
>
	<div
		[matTooltipTemplate]="monthContingentToolTip"
		[matTooltipTemplateContext]="{ date:date, summed:summed, change:change}"
		[ngClass]="hidden ? 'hidden xl:block' : null"
		class="flex justify-center"
		matTooltip
	>
		<span
			[ngClass]="{
				'text-warn': summed < 0,
				'text-success': summed > 0
			}"
			class="flex justify-center text-center font-semibold"
			>{{ summed > 0 ? '+' : summed < 0 ? '-' : '&#8199;' }}{{ summed | parseMsAsDuration: false }}</span
		>
	</div>
</ng-template>

<ng-template
	#monthContingentToolTip
	let-change="change"
	let-date="date"
	let-summed="summed"
>
	<div class="flex flex-col">
		<div class="flex flex-row gap-2">
			<span> {{ "time.plural" | translate }}: </span>
			<span
				[ngClass]="{
					'text-warn': summed< 0,
					'text-success': summed > 0
				}"
			>
				<span> {{ summed > 0 ? '+' : summed < 0 ? '-' : '&#8199;' }} </span>
				<span> {{ summed | parseMsAsDuration: false }} </span>
			</span>
		</div>
		<div class="flex flex-row gap-2 w-full">
			<span> {{ "workspace.timecontingent.change" | translate }} {{ date | date:'MMMM yyyy' }}:</span>
			<span
				[ngClass]="{
					'text-warn': change < 0,
					'text-success': change > 0
				}"
			>
				<span> {{ change > 0 ? '+' : change < 0 ? '-' : '&#8199;' }} </span>
				<span> {{ change | parseMsAsDuration: false }} </span>
			</span>
		</div>
	</div>
</ng-template>

<tg-day-picker-popover
	(viewDateChange)="onViewDateChange($event)"
	[max]="maxDate"
	[viewDate]="range.value$ | async"
	#dayPickerPopover
	rangeType="day"
	showReset="true"
></tg-day-picker-popover>
